import { Injectable } from '@angular/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {
  async getItem(name: string) {
    if (!SecureStoragePlugin) {
      throw new Error('Can not get item - Capacitor Secure Storage is undefined!');
    }
    return SecureStoragePlugin.get({ key: name });
  }

  async setItem(name: string, value: string) {
    if (!SecureStoragePlugin) {
      throw new Error('Can not set item - Capacitor Secure Storage is undefined!');
    }
    return SecureStoragePlugin.set({ key: name, value });
  }

  async clear() {
    if (!SecureStoragePlugin) {
      throw new Error('Can not clear storage - Capacitor Secure Storage is undefined!');
    }
    return SecureStoragePlugin.clear();
  }
}
